export class SkoobeBanner extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.skoobeStableBookId = this.getAttribute("data-skoobe-id");

        this.overlayLink = this.querySelector(".in-app-oeffnen");
        this.overlayLink.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleOpenOverlay();
        });

        this.skoobeAppLink = this.querySelector(".skoobe-app-oeffnen");
        this.skoobeAppLink.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleOpenSkoobeApp();
            this.closeOverlay();
        });

        this.appStoreLink = this.querySelector(".app-store-oeffnen");
        this.appStoreLink.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleOpenAppStore();
            this.closeOverlay();
        });
    }

    handleOpenOverlay = () => {
        this.querySelector(".skoobe-banner-overlay").showModal();
    };

    closeOverlay = () => {
        this.querySelector(".skoobe-banner-overlay").close();
    };

    handleOpenSkoobeApp = () => {
        const skoobeAppDeepLinkURL = "skoobe://book/" + this.skoobeStableBookId;
        window.location.href = skoobeAppDeepLinkURL;
    };

    handleOpenAppStore = () => {
        const appleStoreSkoobieIdentifier = "skoobe-ebooks-and-audiobooks/id425361265";
        const googlePlaySkoobieIdentifier = "net.skoobe.reader";
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.location.href = "https://apps.apple.com/de/app/" + appleStoreSkoobieIdentifier;
        } else if (/android/i.test(userAgent)) {
            window.location.href = "https://play.google.com/store/apps/details?id=" + googlePlaySkoobieIdentifier;
        }
    };
}
if (!customElements.get("skoobe-banner")) {
    customElements.define("skoobe-banner", SkoobeBanner);
}
